import { UpdatePage } from '@components/molecules';
import { SwitchElement, TextFieldElement, useForm } from 'react-hook-form-mui';
import API from '@apps/localization/services/region';
import { ModelProps } from '@/types';
import {
  RegionSchema,
  RegionSchemaType,
} from '@apps/localization/schemas/region';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const defaultValues = {
    is_active: true,
  };

  const formContext = useForm<RegionSchemaType>({
    resolver: zodResolver(RegionSchema),
    defaultValues: defaultValues,
  });

  return (
    <UpdatePage
      schema={RegionSchema}
      api={API}
      modelProps={modelProps}
      title={t('Country')}
      canSaveAndContinue
      formcontext={formContext}
    >
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement name="name" label={t('Name')} fullWidth required />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <SwitchElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </UpdatePage>
  );
}
